<script setup>
import { ref } from "vue"
// import Products from "../data/products.json"
</script>
<script>
export const additions = { icon: "ic_description" }
</script>

<template>
  <h1 class="text-3xl font-bold">{{ t["prod-card"] }}</h1>
</template>
